import { useHistory } from "react-router-dom";
import { BaseInput } from "../../components/Base/BaseInput";
import { Grid, Text, Button, GridItem, Checkbox, Box } from "@chakra-ui/react";
import {
  BookCard,
  BookCardTitle,
  BookCardSubtitle,
} from "../../components/Book/BookCard";
import { useBookingContext } from "../../context/BookingContext";
import { useEffect } from "react";

const GuardianInfoPage = () => {
  const history = useHistory();
  const { stepr } = useBookingContext();

  const handleClickContinue = () => {
    /**
     * TODO: validate form
     */
    stepr.nextStep();
    history.push("/book/child-info");
  };

  useEffect(() => {
    stepr.setStep(0);
  }, [stepr]);

  return (
    <BookCard mt={"10px"} mx="auto">
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box>
          <BookCardTitle small>Parent or Guardian Details</BookCardTitle>
          <BookCardSubtitle small>
            Please Enter Parent/Guardian Details
          </BookCardSubtitle>
        </Box>
        <Box color="#797979" fontSize={"20px"}>
          <i className="ri-information-fill"></i>
        </Box>
      </Box>

      <Grid templateColumns="repeat(2, 1fr)" gap={"10px"} mt={6}>
        <GridItem>
          <BaseInput name="first-name" label="First Name" placeholder="John" />
        </GridItem>
        <GridItem>
          <BaseInput name="last-name" label="Last Name" placeholder="Doe" />
        </GridItem>
        <GridItem colSpan={2} mt={2}>
          <BaseInput
            type="email"
            name="email"
            label="Email"
            placeholder="username@email.com"
          />
        </GridItem>
        <GridItem colSpan={2} mt={2}>
          <BaseInput
            type="tel"
            name="phone"
            label="Phone Number"
            leftElement={"+1"}
            placeholder="(000)000-0000"
          />
        </GridItem>
        <GridItem colSpan={2} mt={2}>
          <Checkbox defaultChecked>
            <Text
              fontFamily={"Inter"}
              fontWeight={400}
              fontSize={"14px"}
              lineHeight={"20px"}
              color={"#374151"}
            >
              I agree to the <a href="#1">Terms of Service</a> and{" "}
              <a href="#2">Privacy Policy</a>
            </Text>
          </Checkbox>
        </GridItem>
        <GridItem colSpan={2} mt={2}>
          <Button
            w={"100%"}
            variant="solid"
            colorScheme="blue"
            fontFamily={"Cairo"}
            fontSize={"14px"}
            fontWeight={700}
            onClick={handleClickContinue}
          >
            Continue
          </Button>
        </GridItem>
      </Grid>
    </BookCard>
  );
};

export { GuardianInfoPage };
